import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState';

const cidadeReducer = (state = InitialState.cidadeReducer, action) => {
    switch (action.type) {
        case ActionType.GET_CIDADE_RESPONSE: {
            return {
                ...state,
                cidadeObject: _.assign(action.cidadeObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default cidadeReducer;